import styled from 'styled-components';
import theme from '../../theme';
export const PageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;

  @media (max-width: 760px) {
    height: auto;
    min-height: 100vh;
    overflow-y: auto;
    padding: 24px 0;
  }
`;

export const Card = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  width: min(920px, 92vw);
  max-height: 88vh;
  border-radius: 28px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(24px) saturate(160%);
  -webkit-backdrop-filter: blur(24px) saturate(160%);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 24px 90px -24px rgba(55, 18, 18, 0.35);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    z-index: 2;
  }

  @media (max-width: 760px) {
    flex-direction: column;
    width: 92vw;
    max-height: none;
  }
`;

export const LeftPanel = styled.div`
  position: relative;
  flex: 0 0 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 40px;
  background: #0b1b2e;

  @media (max-width: 760px) {
    flex: 0 0 auto;
    min-height: 220px;
    padding: 32px 24px;
  }
`;

export const DecorLayer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
`;

export const PanelGlow = styled.div`
  position: absolute;
  top: 38%;
  left: 50%;
  width: 260px;
  height: 260px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: rgba(211, 47, 47, 0.35);
  filter: blur(50px);
`;

export const LockBadge = styled.div`
  position: relative;
  z-index: 1;
  width: 84px;
  height: 84px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  background: #d32f2f;
  color: #fff;
  box-shadow: 0 16px 32px -12px rgba(211, 47, 47, 0.6);
`;

export const BrandBlock = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 260px;
  text-align: center;
`;

export const BadgePill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  margin-bottom: 18px;
  border-radius: 999px;
  border: 1px solid rgba(255, 122, 122, 0.35);
  background: rgba(211, 47, 47, 0.18);
  color: #ffd1d1;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
`;

export const FormLogo = styled.img`
  width: 150px;
  height: auto;
  margin-bottom: 8px;
  opacity: 0.92;
`;

export const BrandName = styled.span`
  margin-top: 10px;
  color: ${theme.cores.white};
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.5px;
`;

export const Tagline = styled.p`
  margin: 10px 0 0;
  color: rgba(255, 255, 255, 0.55);
  font-size: 12.5px;
  line-height: 1.6;
`;

export const RightPanel = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 36px 40px;

  @media (max-width: 760px) {
    padding: 28px 22px;
  }
`;

export const RightHeader = styled.div`
  text-align: center;
  margin-bottom: 20px;

  h1 {
    font-size: 21px;
    color: ${theme.cores.black};
    margin: 0 0 6px;
    text-transform: uppercase;
  }
`;

export const RightSubtitle = styled.p`
  margin: 0;
  color: #81878f;
  font-size: 15px;
`;

export const InfoCard = styled.div`
  background: ${theme.cores.lightGray2};
  border: 1.5px solid ${theme.cores.linha};
  border-left: 4px solid #d32f2f;
  border-radius: 18px;
  padding: 16px 20px;
  margin-bottom: 22px;

  p {
    margin: 4px 0;
    font-size: 13.5px;
    color: #4b5563;
  }

  strong {
    color: ${theme.cores.black};
  }
`;

export const SectionTitle = styled.h4`
  font-size: 14.5px;
  font-weight: 700;
  color: ${theme.cores.black};
  margin: 0 0 12px;
`;

export const BoletosList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const BoletoCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  background: ${theme.cores.lightGray2};
  border: 1.5px solid ${theme.cores.linha};
  border-radius: 18px;
  padding: 16px 20px;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;

  &:hover {
    border-color: rgba(211, 47, 47, 0.4);
    box-shadow: 0 8px 20px -12px rgba(211, 47, 47, 0.3);
  }
`;

export const BoletoInfo = styled.div`
  flex: 1 1 200px;

  p {
    margin: 2px 0;
    font-size: 13px;
    color: #4b5563;
  }

  .valor-total {
    font-size: 17px;
    font-weight: 800;
    color: #d32f2f;
    margin-top: 6px;
  }
`;

export const PixArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  img {
    width: 110px;
    height: 110px;
    border-radius: 10px;
    border: 1.5px solid ${theme.cores.linha};
    background: ${theme.cores.white};
  }
`;

export const PixCopyButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  border: 0;
  border-radius: 999px;
  padding: 8px 16px;
  font-size: 12.5px;
  font-weight: 700;
  color: ${theme.cores.white};
  cursor: pointer;
  background: ${theme.cores.login};
  box-shadow: 0 10px 20px -10px rgba(47, 111, 237, 0.55);
  transition: transform 0.15s ease;

  &:hover {
    transform: translateY(-1px);
  }
`;

export const BoletoLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: ${theme.cores.login};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const EmptyBoletos = styled.p`
  color: #8a93a3;
  font-size: 13.5px;
`;

export const FooterLinks = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 26px;

  button {
    display: flex;
    align-items: center;
    gap: 6px;
    background: transparent;
    border: 1.5px solid ${theme.cores.linha};
    border-radius: 999px;
    padding: 9px 20px;
    color: #6b7280;
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
    transition:
      border-color 0.2s,
      color 0.2s;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    &:hover:not(:disabled) {
      border-color: #d32f2f;
      color: #d32f2f;
    }
  }
`;
